import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import {catchError} from 'rxjs/operators';

import { AuthService } from '../auth.service';
import { EN_SEGUNDO_PLANO } from './peticion-de-fondo';
import { UrlConstantes } from '../../utilerias/constantes/urlconstantes';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            // auto logout if 401 response returned from api.
            // Salvo si la peticion era de fondo: recargar la pagina por
            // un refresco automatico le arrancaria la pantalla de las
            // manos a quien estuviera escribiendo. El error llega al
            // componente, que apaga su refresco, y la siguiente accion
            // de verdad del usuario si lo mandara al login.
            // Tampoco en el propio login: ahi el 401 es "usuario o
            // contrasena incorrectos" y lo avisa loginUser con el motivo
            // que manda el servidor; recargar lo borraba sin decir nada.
            const esLogin = request.url === UrlConstantes.loginAdmin;
            if (err.status === 401 && !esLogin && !request.context.get(EN_SEGUNDO_PLANO)) {
                this.authenticationService.logout();
                location.reload();
            }

            // const error = err.error.message || err.statusText;
            const error = err;
            return throwError(error);
        }))
    }
}
